// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import { MultiLineStrings } from "imagus-components";

import type { DictionaryType } from "../../global/types/GeneralTypes";
import type { ButtonStylesClassesType } from "../../global/styles/buttonStyles";
import { buttonStyles } from "../../global/styles/buttonStyles";
import Properties from "../../../Properties";
import LogoImage from "../../../images/logo.svg";

const root = Properties.facedb_root;

const styles = (theme: DictionaryType): DictionaryType => ({
  ...buttonStyles(theme),
  flagWrapper: {

    color: theme.palette.common.black,
    width: "100%",
    padding: "24px 20px",
    lineHeight: "30px"
  },
  verticalCenter: {
    marginTop: "15%"
  },
  flagText: {
    textAlign: "center"
  },
  flagTitle: {
    fontSize: "1.875rem",
    fontWeight: "800",
    lineHeight: "60px"
  },
  flagContent: {
    whiteSpace: "pre-wrap"
  },
  button: {
    marginTop: "15px"
  },
  checkMark: {
    width: "100px",
    display: "block",
    margin: "0 auto"
  },
  docStyles: {
    width: "100%",
    height: "100vh",
    maxHeight: window.innerHeight - 10,
    [theme.breakpoints.down("xs")]: {
      maxHeight: "100%",
    },
  },

  root: {
    display: "flex",
    flexDirection: "column",
    width: "auto",
    height: "100vh",
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "65px",
    },
  },
});



type SoftwareDocumentIframePropsType = {
  classes: CompleteMessageClassesType,
  src: string
};

const SoftwareDocumentIframe = ({
  classes,
  src,
}: SoftwareDocumentIframePropsType): React$Element<"div"> => {
  return (
    <div id="iframe-wrap" className={classes.root}>
      <iframe
        src={`${root}/${src}`}
        title="Documentation"
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    </div>
  );
};

export default withStyles(styles)(SoftwareDocumentIframe);
